
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz';
import FormCheckbox from './form-checkbox';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formcheckbox"
    }}>{`FormCheckbox`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "checkbox"
    }}>{`Checkbox`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For a set of selectable values. In a group of checkbox inputs, multiple values may be selected.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<FormCheckbox labelText=\"Input text\" id=\"checkboxRegular\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckbox
    }} mdxType="Playground">
  <FormCheckbox labelText='Input text' id='checkboxRegular' mdxType="FormCheckbox" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={2} __code={'<FormCheckbox labelText=\"Input text\" id=\"checkboxDisabled\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckbox
    }} mdxType="Playground">
  <FormCheckbox labelText='Input text' id='checkboxDisabled' disabled mdxType="FormCheckbox" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={3} __code={'<FormCheckbox\n  labelText=\"Input text\"\n  id=\"checkboxSelected\"\n  defaultChecked={true}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckbox
    }} mdxType="Playground">
  <FormCheckbox labelText='Input text' id='checkboxSelected' defaultChecked={true} mdxType="FormCheckbox" />
    </Playground>
    <p><strong parentName="p">{`Selected and disabled`}</strong></p>
    <Playground __position={4} __code={'<FormCheckbox\n  labelText=\"Input text\"\n  id=\"checkboxSelectedDisabled\"\n  defaultChecked={true}\n  disabled\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckbox
    }} mdxType="Playground">
  <FormCheckbox labelText='Input text' id='checkboxSelectedDisabled' defaultChecked={true} disabled mdxType="FormCheckbox" />
    </Playground>
    <p><strong parentName="p">{`Indeterminate`}</strong></p>
    <Playground __position={5} __code={'<FormCheckbox\n  labelText=\"Input text\"\n  id=\"checkboxIndeterminate\"\n  isIndeterminate\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckbox
    }} mdxType="Playground">
  <FormCheckbox labelText='Input text' id='checkboxIndeterminate' isIndeterminate mdxType="FormCheckbox" />
    </Playground>
    <p><strong parentName="p">{`Indeterminate and disabled`}</strong></p>
    <Playground __position={6} __code={'<FormCheckbox\n  labelText=\"Input text\"\n  id=\"checkboxIndeterminate\"\n  isIndeterminate\n  disabled\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckbox
    }} mdxType="Playground">
  <FormCheckbox labelText='Input text' id='checkboxIndeterminate' isIndeterminate disabled mdxType="FormCheckbox" />
    </Playground>
    <p><strong parentName="p">{`Other use-cases`}</strong></p>
    <Playground __position={7} __code={'<FormCheckbox labelText=\"A checkbox...\" id=\"other-1\" />\n<br />\n<FormCheckbox\n  labelText=\"Side-by-side another one with a lot of text which should wrap when needed\"\n  id=\"other-2\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckbox
    }} mdxType="Playground">
  <FormCheckbox labelText='A checkbox...' id='other-1' mdxType="FormCheckbox" />
  <br />
  <FormCheckbox labelText='Side-by-side another one with a lot of text which should wrap when needed' id='other-2' mdxType="FormCheckbox" />
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormCheckbox} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;